// extracted by mini-css-extract-plugin
export default {"section":"Portfolio_section__AG-UG","inner":"Portfolio_inner__76GMl","title":"Portfolio_title__iejNi","portfolioContainer":"Portfolio_portfolioContainer__EBCz9"};